import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=70afa676&scoped=true&"
import script from "./latest.vue?vue&type=script&lang=js&"
export * from "./latest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afa676",
  null
  
)

export default component.exports